const { atom } = require("recoil");

export const checkinDetailState = atom({
  key: "checkinDetailState",
  default: [],
});

export const anchorElState = atom({
  key: "anchorElState",
  default: null,
});

export const downloadLoaderState = atom({
  key: "downloadLoaderState",
  default: false,
});

export const surveyResponseState = atom({
  key: "surveyResponseState",
  default: [],
});

export const checkinDetailsVariables = atom({
  key: "checkinDetailsVariables",
  default: {},
});

export const checkinRespondedState = atom({
  key: "checkinRespondedState",
  default: false,
});

export const IsNewValueState = atom({
  key: "IsNewValueState",
  default: false,
});

export const checkinGridState = atom({
  key: "checkinGridState",
  default: [],
});

export const learningResponseModalState = atom({
  key: "learningResponseModalState",
  default: false,
});

export const surveySummaryState = atom({
  key: "surveySummaryState",
  default: [],
});

export const learningResponseState = atom({
  key: "learningResponseState",
  default: false,
});

export const displayLinkState = atom({
  key: "displayLinkState",
  default: {},
});

export const questionDisableState = atom({
  key: "questionDisableState",
  default: true,
});

export const allCheckinTitle = atom({
  key: "allCheckinTitle",
  default: [],
});
export const checkinDetailsExpandState = atom({
  key: "checkinDetailsExpandState",
  default: false,
});
export const checkinOverviewLoaderState = atom({
  key: "checkinOverviewLoaderState",
  default: {
    learningLoader: false,
    surveyQuestionWiseLoader: false,
    surveyPeopleWiseLoader: false,
  },
});
export const authPageState = atom({
  key: "authPageState",
  default: false
})

export const openModalState = atom({
  key: "openModalState",
  default: false
})

export const loaderState = atom({
  key: "loaderState",
  default: false
})
